import React from 'react';
import { useQuery } from 'react-query';
import { dashboardAPI } from '../services/api';
import StatCard from '../components/dashboard/StatCard';
import ChartCard from '../components/dashboard/ChartCard';
import ActivityFeed from '../components/dashboard/ActivityFeed';
import toast from 'react-hot-toast';

const DashboardPage = () => {
  // 获取仪表盘概览数据
  const { data: overviewData, isLoading: overviewLoading } = useQuery(
    'dashboardOverview',
    () => dashboardAPI.getOverview(),
    {
      refetchInterval: 60000, // 每分钟刷新一次
    }
  );

  // 获取巡检图表数据
  const { data: inspectionChartData } = useQuery(
    'inspectionChart',
    () => dashboardAPI.getInspectionChart()
  );

  // 获取培训图表数据
  const { data: trainingChartData } = useQuery(
    'trainingChart',
    () => dashboardAPI.getTrainingChart()
  );

  // 获取最近活动
  const { data: activitiesData } = useQuery(
    'recentActivities',
    () => dashboardAPI.getActivities()
  );

  if (overviewLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="spinner mx-auto"></div>
          <p className="mt-4 text-gray-600">加载数据中...</p>
        </div>
      </div>
    );
  }

  const overview = overviewData || {};
  const inspections = overview.inspections || {};
  const trainings = overview.trainings || {};
  const certificates = overview.certificates || {};
  const activities = activitiesData?.activities || [];

  const statCards = [
    {
      title: '待处理巡检任务',
      value: inspections.pending || 0,
      icon: 'fa-check-square-o',
      color: 'primary',
      trend: inspections.overdue > 0 ? 'danger' : 'neutral',
      trendText: inspections.overdue > 0 ? `${inspections.overdue}个逾期` : '正常',
      link: '/inspections?status=pending'
    },
    {
      title: '待开展培训',
      value: trainings.pending || 0,
      icon: 'fa-graduation-cap',
      color: 'success',
      trend: 'neutral',
      trendText: `${trainings.total || 0}个培训`,
      link: '/trainings?status=pending'
    },
    {
      title: '即将过期证件',
      value: certificates.expiring || 0,
      icon: 'fa-id-card-o',
      color: 'warning',
      trend: certificates.expired > 0 ? 'danger' : 'neutral',
      trendText: certificates.expired > 0 ? `${certificates.expired}个已过期` : '正常',
      link: '/certificates?status=expiring'
    },
    {
      title: '有效证件',
      value: certificates.total || 0,
      icon: 'fa-exclamation-triangle',
      color: 'danger',
      trend: 'neutral',
      trendText: '总计',
      link: '/certificates'
    }
  ];

  return (
    <div className="space-y-6">
      {/* 页面标题 */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">仪表盘</h1>
        <p className="text-gray-600 mt-1">欢迎回来，这里是系统概览</p>
      </div>

      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((card, index) => (
          <StatCard key={index} {...card} />
        ))}
      </div>

      {/* 图表区域 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ChartCard
          title="巡检完成情况"
          chartData={inspectionChartData?.chart_data}
          type="doughnut"
        />
        <ChartCard
          title="培训参与情况"
          chartData={trainingChartData?.chart_data}
          type="bar"
        />
      </div>

      {/* 最近活动 */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-200">
          <h2 className="text-lg font-medium text-gray-900">最近活动</h2>
        </div>
        <div className="divide-y divide-gray-200">
          {activities.length > 0 ? (
            activities.map((activity, index) => (
              <ActivityFeed key={index} activity={activity} />
            ))
          ) : (
            <div className="px-6 py-8 text-center">
              <i className="fa fa-history text-gray-300 text-4xl mb-3"></i>
              <p className="text-gray-500">暂无活动记录</p>
            </div>
          )}
        </div>
        {activities.length > 0 && (
          <div className="px-6 py-3 bg-gray-50 border-t border-gray-200 text-center">
            <button
              className="text-sm font-medium text-primary hover:text-blue-700"
              onClick={() => {
                toast.success('功能开发中...');
              }}
            >
              查看所有活动
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardPage;